var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLessonBlockedIc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 9.5,
    stroke: "#98BDBD",
    strokeDasharray: "2 2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#lesson_blocked_ic_svg__clip0_2167_5698)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#lesson_blocked_ic_svg__clip1_2167_5698)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.334 27.5a7.5 7.5 0 01-5.929-12.094l10.523 10.523a7.467 7.467 0 01-4.594 1.571zm5.998-2.996A7.5 7.5 0 0015.83 14.003l10.5 10.5zM11.167 20A9.167 9.167 0 1029.5 20a9.167 9.167 0 00-18.333 0z",
    fill: "#98BDBD"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "lesson_blocked_ic_svg__clip0_2167_5698"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(10 10)",
    d: "M0 0h20v20H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "lesson_blocked_ic_svg__clip1_2167_5698"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "rotate(-90 20 10)",
    d: "M0 0h20v20H0z"
  })))));
}
export default SvgLessonBlockedIc;